import type { TFunction } from 'i18next';

/**
 * Safely resolve a translation key, falling back to the provided message when the key is missing.
 */
export function translateWithFallback(t: TFunction, key: string, defaultValue: string): string {
  return t(key, { defaultValue });
}
